module.exports = __webpack_public_path__ + "img/sport-m-2.d8648405.jpg";